<div id="youth-red-cross" class="inner-page">
  <div class="container-fluid px-lg-5">

    <h2 class="title">Youth Red Cross & Red Ribbon Club</h2>
    <p class="inner-lead mt-3">
      Shah Satnam Ji Girls' College takes great pride in hosting the Youth Red Cross (YRC) and Red Ribbon Club, which
      have been pivotal in fostering a culture of community service, health awareness, and social responsibility for
      many years. These organizations have played a significant role in driving various initiatives that contribute to
      the well-being of both the college community and the broader society.
    </p>

    <hr class="divider">

    <p>Youth Red Cross (YRC) has been instrumental in promoting humanitarian values and providing a platform for
      students to engage in meaningful service activities. The key initiatives include organizing regular blood donation
      camps, conducting health check-up camps, and training the team to assist in disaster management and relief
      operations.</p>

    <p>The Red Ribbon Club is dedicated to raising awareness about HIV/AIDS, promoting safe practices, and reducing the
      stigma associated with the disease. Their major contributions include organizing regular seminars, workshops, and
      interactive sessions to educate students about HIV/AIDS, conducting community outreach activities, and providing
      health and wellness programs such as free HIV testing camps and counselling sessions.</p>

    <p>Both YRC and the Red Ribbon Club work in close collaboration with local health authorities, non-governmental
      organizations, and other educational institutions, leading to significant achievements such as increased health
      awareness, improved community health standards, and enhanced student participation in social service.</p>

    <p>The college remains committed to providing an environment that nurtures compassion, leadership, and a proactive
      approach to societal issues as these clubs continue to expand their outreach and impact.</p>

    <hr class="divider">

    <h4 class="section-subtitle">Committee</h4>

    <h5 class="mt-3">YRC</h5>
    <ul class="list-styled">
      <li><strong>Convener:</strong> Dr. Monika</li>
      <li><strong>Members:</strong> Ms. Geeta, Ms. Jasbir Kaur, Ms. Tajinder Kaur</li>
    </ul>

    <h5 class="mt-3">Red Ribbon Club</h5>
    <ul class="list-styled">
      <li><strong>Convener:</strong> Dr. Monika</li>
      <li><strong>Members:</strong> Dr. Rekha, Ms. Payal</li>
    </ul>

    <hr class="divider">

    <h4 class="section-subtitle">Youth Red Cross Reports</h4>
    <div class="row g-3 mt-2">
      <div class="col-md-4">
        <a href="/assets/pdf/yrc/Youth-Red-Cross2023-24.pdf" target="_blank" class="pdf-download-btn w-100 text-center">
          <i class="fa fa-file-pdf-o me-2"></i>Youth Red Cross 2023-24
        </a>
      </div>
      <div class="col-md-4">
        <a href="/assets/pdf/yrc/Youth-Red-Cross2022-23.pdf" target="_blank" class="pdf-download-btn w-100 text-center">
          <i class="fa fa-file-pdf-o me-2"></i>Youth Red Cross 2022-23
        </a>
      </div>
      <div class="col-md-4">
        <a href="/assets/pdf/yrc/Youth-Red-Cross2021-22.pdf" target="_blank" class="pdf-download-btn w-100 text-center">
          <i class="fa fa-file-pdf-o me-2"></i>Youth Red Cross 2021-22
        </a>
      </div>
    </div>

    <hr class="divider">

    <h4 class="section-subtitle">Photo Gallery</h4>
    <div class="row g-3 mt-2 mb-4">
      <div class="col-6 col-md-3" *ngFor="let img of yrcImages">
        <div class="rounded-4 overflow-hidden shadow-sm border border-2 border-white">
          <img [src]="img" alt="Youth Red Cross Activity" class="img-fluid w-100" style="object-fit: cover; height: 180px;">
        </div>
      </div>
    </div>

  </div>
</div>